import axios from "@/lib/request";

// ===== 平安干线保相关接口 =====

// 获取平安干线保保险订单列表 (对应老项目paList.html)
export const getPingAnTrunkInsuranceList = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/order/internal/list",
    method: "get",
    params: {
      ...params,
      insurance_type: 144
    },
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取平安干线保保险订单总金额
export const getPingAnTrunkInsuranceSum = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/order/internal/price",
    method: "get",
    params: {
      ...params,
      insurance_type: 144
    },
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取平安干线保大保单列表 (对应老项目paPolicyList.html)
export const getPingAnTrunkOrderList = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/pingan/policy/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取平安干线保订单详情
export const getPingAnTrunkOrderInfo = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/pingan/policy/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除平安干线保订单
export const deletePingAnTrunkOrder = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/pingan/policy/delete",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 修改平安干线保订单
export const updatePingAnTrunkOrder = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/pingan/policy/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 导出平安干线保保险订单Excel
export const exportPingAnTrunkInsuranceExcel = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/order/list",
    method: "get",
    params: {
      ...params,
      insurance_type: 144
    },
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 导出平安干线保大保单Excel
export const exportPingAnTrunkOrderExcel = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/pingan/policy/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 补发昨日订单申报邮件
export const sendYesterdayOrderEmail = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/reissue/email",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存平安干线保订单
export const savePingAnTrunkOrder = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/pingan/policy/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新发票信息
export const updatePingAnTrunkInvoice = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/pingan/policy/invoiceurl",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 上传保单文件
export const uploadPingAnTrunkPolicyFile = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/pingan/policy/url",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取平安干线保单信息 (用于开票信息页面)
export const getPingAnTrunkPolicyInfo = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/pingan/policy/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新平安干线保单信息 (用于开票信息保存)
export const updatePingAnTrunkPolicy = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/pingan/policy/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 上传投保单URL (用于获取电子保单页面)
export const uploadPingAnTrunkPolicyUrl = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/pingan/policy/url",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};